var _rect, _circle, _text, _text2, _text3, _path, _rect2, _text4, _rect3, _text5, _rect4, _text6, _text7, _text8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertEvaluateCycleBuilderPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 700,
    viewBox: "0 0 1200 700",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 700,
    rx: 24,
    fill: "#0f172a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1100,
    cy: 80,
    r: 280,
    fill: "#172d50"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 92,
    fill: "#93c5fd",
    fontFamily: "Arial,sans-serif",
    fontSize: 20,
    letterSpacing: 3
  }, "ALERTEVALUATE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 220,
    fill: "#f8fafc",
    fontFamily: "Arial,sans-serif",
    fontSize: 56,
    fontWeight: "bold"
  }, "Configure the appraisal")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 274,
    fill: "#cbd5e1",
    fontFamily: "Arial,sans-serif",
    fontSize: 26
  }, "Ordered stages \xB7 Assigned actors \xB7 Form setup")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 414H980",
    stroke: "#64748b",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 354,
    width: 324,
    height: 120,
    rx: 16,
    fill: "#1e293b",
    stroke: "#64748b"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 425,
    fill: "#f8fafc",
    fontFamily: "Arial,sans-serif",
    fontSize: 28
  }, "Prepare")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 432,
    y: 354,
    width: 324,
    height: 120,
    rx: 16,
    fill: "#1e40af",
    stroke: "#64748b"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 425,
    fill: "#f8fafc",
    fontFamily: "Arial,sans-serif",
    fontSize: 28
  }, "Configure")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 792,
    y: 354,
    width: 324,
    height: 120,
    rx: 16,
    fill: "#1e293b",
    stroke: "#64748b"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 425,
    fill: "#f8fafc",
    fontFamily: "Arial,sans-serif",
    fontSize: 28
  }, "Publish")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 582,
    fill: "#93c5fd",
    fontFamily: "Arial,sans-serif",
    fontSize: 21
  }, "ILLUSTRATIVE PLACEHOLDER \xB7 NOT A PRODUCT SCREENSHOT")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 628,
    fill: "#cbd5e1",
    fontFamily: "Arial,sans-serif",
    fontSize: 22
  }, "Reserved for an approved capture with synthetic data.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertEvaluateCycleBuilderPlaceholder);
export default __webpack_public_path__ + "static/media/alert-evaluate-cycle-builder-placeholder.2e798dde3caf0e2663392ea9d74ff1d5.svg";
export { ForwardRef as ReactComponent };